import styled, { css } from 'styled-components';
import { BaSeTheme } from '../../../theme';

export const DataPaginationWrapper = styled.div.attrs({
  className: 'BaSe--data-pagination',
})<{ compactMode?: boolean }>`
  height: 3em;
  display: flex;
  align-items: center;

  ${({ compactMode }) =>
    compactMode &&
    css`
      flex-wrap: wrap;
      height: auto;
      min-height: 3em;

      ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(`
        & > :first-child,
        & > .BaSe--data-pagination-controller {
          flex: 1 0 100%;
          justify-content: center;
          text-align: center;
        }
      `)}
    `}
`;

export const DataPaginationController = styled.div.attrs({
  className: 'BaSe--data-pagination-controller',
})`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 3em;
  gap: 0.25em;
`;

export const DataPaginationFixedItem = styled.div`
  width: 2em;
`;

export const DataPaginationPageStatus = styled.span`
  white-space: nowrap;
`;
